module.exports = __webpack_public_path__ + "img/f.558a06c1.jpg";